import { Toggle, } from '@eta/components';
import { Icon, TooltipHost, ITooltipHostStyles, } from '@fluentui/react';
import React, { FC } from 'react';
import './PermessionItem.scss';

export interface PermessionItemProps {
    id: string;
    disabled?: boolean;
    checked?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    textConent: any;
    noteContent: string;
    onChangeEvent: (checked: boolean, id: string) => void;
}

const PermessionItem: FC<PermessionItemProps> = (
    props: PermessionItemProps
) => {
    const { id, disabled, checked, textConent, noteContent, onChangeEvent } = props;
    const calloutProps = { gapSpace: 0 };
    const hostStyles: Partial<ITooltipHostStyles> = { root: { display: 'inline-block' } };
    return (
        <div className='PermessionItemContainer'>
            <Toggle className='toggle'
                id={id}
                disabled={disabled}
                checked={checked}
                onText={textConent}
                offText={textConent}
                onChange={(_, c) => {
                    if (onChangeEvent) onChangeEvent(c ?? false, id);
                }}
            />
            <TooltipHost
                content={noteContent}
                calloutProps={calloutProps}
                styles={hostStyles}
            >
                <Icon iconName='info' />
            </TooltipHost>
        </div>
    );
};

export default PermessionItem;
